import { Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import { paragraphMixins } from 'design-system/mixins/text';
import { TransitionDuration } from 'design-system/variables/transitions';

const FormGroup = styled('div')`
  margin-bottom: ${Spacing[4]};

  label {
    ${paragraphMixins.mdBold};
    font-family: inherit; /* override mixin default of Rubik */
    margin-bottom: ${Spacing[2]};
    transition-duration: ${TransitionDuration.Fast};
  }

  &:focus-within label {
    color: ${(props) => props.theme.colorPrimary};
  }
`;

export default FormGroup;
